/**
 * LeadVideo
 * @module components/LeadVideo/LeadVideo
 */

import React, { useState, useEffect } from 'react';

import cx from 'classnames';
import { useIntl, defineMessages } from 'react-intl';
import { Icon } from 'semantic-ui-react';

const messages = defineMessages({
  playVideo: {
    id: 'Play Video',
    defaultMessage: 'Play Video',
  },
  pauseVideo: {
    id: 'Pause Video',
    defaultMessage: 'Pause Video',
  },
});

const LeadVideo = ({
  id = new Date().getTime() + '-lead-video',
  children,
  poster,
  url,
  mimeType,
  autoPlay = true,
  muted = true,
  loop = true,
  className,
}) => {
  const intl = useIntl();
  const [userAutoplay, setUserAutoplay] = useState(autoPlay);

  const togleAutoplay = () => {
    if (userAutoplay) {
      document.getElementById(id).pause();
      setUserAutoplay(false);
    } else {
      document.getElementById(id).play();
      setUserAutoplay(true);
    }
  };

  //questo useeffect serve per cambiare lo stato di autoplay interno al componente, quando il video viene stoppato da js esterno (vedi MultiVideoManager)
  useEffect(() => {
    const videoElement = document.getElementById(id);
    if (videoElement) {
      videoElement.addEventListener('play', () => {
        if (!userAutoplay) {
          setUserAutoplay(true);
        }
      });
      videoElement.addEventListener('pause', () => {
        if (userAutoplay) {
          setUserAutoplay(false);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {url && (
        <div className={cx('lead-video-wrapper', className)}>
          {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
          <video
            id={id}
            loop={loop}
            muted={muted}
            autoPlay={autoPlay}
            poster={poster}
          >
            <source type={mimeType} src={url} />
          </video>

          {children}

          <div className="play-pause-wrapper">
            <button
              onClick={() => togleAutoplay()}
              title={
                userAutoplay
                  ? intl.formatMessage(messages.pauseVideo)
                  : intl.formatMessage(messages.playVideo)
              }
            >
              <Icon name={userAutoplay ? 'pause' : 'play'} />
              <span>{userAutoplay ? 'pause' : 'play'}</span>
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default LeadVideo;
